import React, { createContext, useContext, useMemo, useState } from 'react';
import { ScheduleActionsContainerTypes } from '../types';

// context
const ScheduleActionsContainerContext = createContext<ScheduleActionsContainerTypes>(
  {} as ScheduleActionsContainerTypes
);

// provider
interface ScheduleActionsContainerProps {
  children: React.ReactNode;
  closeModal?: () => void;
  isSmallModeWindow?: boolean;
}

export const ScheduleActionsContainerProvider = React.memo(
  ({ children, closeModal, isSmallModeWindow }: ScheduleActionsContainerProps) => {
    const [selectedLocationId, setSelectedLocationId] = useState<string | null>(null);
    const [hideTabs, setHideTabs] = useState(false);
    const [selectedDate, setSelectedDate] = useState<string>('');

    const actions = useMemo(
      () => ({
        setHideTabs,
        hideTabs,
        selectedLocationId,
        setSelectedLocationId,
        closeModal,
        setSelectedDate,
        selectedDate,
        isSmallModeWindow,
      }),
      [hideTabs, selectedLocationId, selectedDate, closeModal, isSmallModeWindow]
    );

    return (
      <ScheduleActionsContainerContext.Provider value={actions}>{children}</ScheduleActionsContainerContext.Provider>
    );
  }
);

ScheduleActionsContainerProvider.displayName = 'ScheduleActionsContainerProvider';

// hook
export const useScheduleActionsContainerMethod = () => useContext(ScheduleActionsContainerContext);
